// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ProvinciasFilterMultiSelect_autocomplete-style__-CtC3{width:300}`, "",{"version":3,"sources":["webpack://./src/components/ProvinciasFilterMultiselect/ProvinciasFilterMultiSelect.module.scss"],"names":[],"mappings":"AAAA,uDACI,SAAA","sourcesContent":[".autocomplete-style {\n    width: 300;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"autocomplete-style": `ProvinciasFilterMultiSelect_autocomplete-style__-CtC3`
};
export default ___CSS_LOADER_EXPORT___;
